import { IUserItem } from '../models/userItem'

export const users = (state: IUserItem[] = [], action: any): IUserItem[] => {
	switch (action.type) {
		case 'Users.Load':
			return [
				...action.users
			]
		default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/reducers/users.ts